import { ReactNode } from 'react';
import { useProfile } from '../contexts/ProfileContext';
import { needsTermsAcceptance } from '../constants/terms';

interface Props {
  children: ReactNode;
}

/**
 * Gate de aceite de termos.
 *
 * Quando o profile carregou e o aceite está ausente ou é de uma versão
 * anterior dos termos, suprime o children — o modal não-fechável de `App.tsx`
 * é renderizado em paralelo (top-level) e fica visível sobre a tela em branco,
 * forçando aceite antes de qualquer fetch das páginas internas.
 *
 * Defesa em profundidade: o backend também rejeita mutações com 403
 * `TERMS_NOT_ACCEPTED` (`requireTermsAccepted` middleware).
 */
export default function RequireTermsAccepted({ children }: Props) {
  const { data, loading } = useProfile();

  if (loading) return null;
  if (needsTermsAcceptance(data)) return null;

  return <>{children}</>;
}
